import { ProductTileView2, ProductPriceView2 } from '@obvio/template'
import { GridItem } from '@obvio/ui'

import {
  Interactive,
  GridWrap,
  ProductTitle,
  GridWishlist,
  Wishlist,
} from './components'
import { useCursorContext } from '@/components/Cursor'

import type { PRODUCT_SELECT } from '../StorePage'
import type { Schema } from '@obvio/app'
import type { DeepPick } from '@obvio/utils'
import type { ReactElement } from 'react'

function ImgWrap({ children }: { children: ReactElement }): ReactElement {
  const { setValue } = useCursorContext()
  return (
    <Interactive
      onMouseLeave={() => setValue(null)}
      onMouseEnter={() => setValue('BUY')}
    >
      {children}
    </Interactive>
  )
}

type ProductTileProps = {
  product: DeepPick<Schema['Product'], typeof PRODUCT_SELECT>
  className?: string
}

export function ProductTile({
  product,
  className,
}: ProductTileProps): ReactElement {
  const withMockImages: ProductTileProps['product'] =
    product.images.length === 0
      ? { ...product, images: [{ ratio: 1, name: '' }] }
      : product

  return (
    <ProductTileView2
      noWishlist
      className={className}
      imgWrap={ImgWrap}
      infoNode={({ product: node }) => (
        <GridWrap templateColumns="3fr 1fr" templateRows="1fr 1fr">
          <ProductTitle>
            {product.merchant?.name} - {node.title}
          </ProductTitle>
          <GridWishlist noCenter>
            <Wishlist productId={node.id} />
          </GridWishlist>
          <GridItem noCenter colSpan="2">
            <ProductPriceView2
              price={product.price?.price}
              regularPrice={product.price?.regularPrice}
              lowestPriceBeforeSale={product.price?.lowestPriceBeforeSale}
            />
          </GridItem>
        </GridWrap>
      )}
      product={withMockImages}
    />
  )
}
